import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import LecturesModal from "./LecturesModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getCourseLecturesAction,
  getCoursesAction,
} from "../../redux/actions/courseAction";
import { Toaster, toast } from "react-hot-toast";
import { MdDeleteForever, MdOutlineViewAgenda } from "react-icons/md";
import { deleteCourseAction } from "../../redux/actions/adminAction";

const AdminCoursePage = () => {
  const [showLectures, setShowLectures] = useState(false);

  const { courses } = useSelector((state) => state.courses);
  const { loading, message } = useSelector((state) => state.admin);
  const [courseID, setCouseID] = useState();
  const [courseName, setCoursename] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCoursesAction());

    if (loading) {
      toast.success("Loading...");
      dispatch({
        type: "clearMessage",
      });
    }

    if (message?.message) {
      toast.success(message?.message);
      dispatch({
        type: "clearMessage",
      });
    }
  }, [dispatch, courses?.courses, loading, message]);

  const deleteCourseHandler = (_id) => {
    // console.log(_id);
    dispatch(deleteCourseAction(_id));
  };

  const getCourseLecturesHandler = (_id, title) => {
    setCouseID(_id);
    setCoursename(title);
    dispatch(getCourseLecturesAction(_id));
  };

  return (
    <>
      <Toaster />
      {showLectures && (
        <div className="z-20 fixed translate-y-2 ease-in w-full h-full bg-white">
          {" "}
          <LecturesModal
            coursename={courseName}
            id={courseID}
            setShowLectures={setShowLectures}
          />{" "}
        </div>
      )}
      <div className="grid grid-cols-5">
        <div className="">
          <AdminSidebar />
        </div>
        <div className="col-span-4 py-20">
          <div className="w-full px-20">
            {/* form  */}
            <h1 className="font-semibold text-2xl my-6">All Courses</h1>
            <table className="">
              <thead className="bg-[#F1F4FF] ">
                <tr className="text-blue-700 border">
                  <th className="py-2">#</th>

                  <th className="py-2">Name</th>
                  <th className="py-2">Description</th>
                  <th className="py-2">Lectures</th>
                  <th className="py-2">Tags</th>
                  <th className="py-2">Creator</th>
                  <th className="py-2">Created at</th>
                  <th className="py-2">Delete</th>
                  <th className="py-2">View</th>
                </tr>
              </thead>
              <tbody className="bg-[#F1F4FF]  ">
                {courses.map((course, index) => (
                  <tr
                    className="border font-semibold text-gray-700"
                    key={course._id}
                  >
                    <td className="px-3 py-2 ">{index + 1}</td>

                    <td className="px-3 py-2 ">{course?.title}</td>
                    <td className="px-3 py-2 ">{course?.description}</td>
                    <td className="px-3 py-2 ">{course?.numOfVideos}</td>
                    <td className="px-3 py-2 ">{course?.category}</td>

                    <td className="px-3 py-2 ">{course?.createdBy}</td>
                    <td className="px-3 py-2 ">
                      {course?.createdDate.split("T")[0]}
                    </td>
                    <td className="px-3 py-2 ">
                      <button
                        onClick={(e) => {
                          deleteCourseHandler(course._id);
                        }}
                        className="bg-red-500 text-white px-2 py-2 rounded-sm"
                      >
                        <MdDeleteForever />
                      </button>
                    </td>

                    <td className="px-3 py-2 ">
                      <button
                        onClick={(e) => {
                          setShowLectures(!showLectures);
                          getCourseLecturesHandler(course._id, course.title);
                        }}
                        className="bg-blue-500 text-white px-2 py-2 rounded-sm "
                      >
                        <MdOutlineViewAgenda />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminCoursePage;
